import { render, staticRenderFns } from "./upload-files-modal.vue?vue&type=template&id=b5af045a"
import script from "./upload-files-modal.vue?vue&type=script&lang=js"
export * from "./upload-files-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports